import React from 'react';

import style from '_atoms/Button/index-shimmer.module.scss';

const ButtonShimmer = () => <div className={style.button} />;

export default ButtonShimmer;
